import { memo } from 'react';

import { type BoardCustomFieldValue } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

import {
  PanelCustomFieldContainer,
  type PanelCustomFieldContainerProps,
} from '~/components/RightPanel/CustomFields/PanelCustomFieldContainer';

export type PublicBoardPanelCustomFieldContainerProps = Omit<
  PanelCustomFieldContainerProps<BoardCustomFieldValue>,
  'canDeleteCustomFields' | 'canEditCustomFields' | 'onClick'
>;

export const PublicBoardPanelCustomFieldContainer = memo(
  ({ className, ...params }: PublicBoardPanelCustomFieldContainerProps) => {
    return (
      <PanelCustomFieldContainer
        canDeleteCustomFields={false}
        canEditCustomFields={false}
        {...params}
        className={cn('ui2026:mb-3', className)}
      />
    );
  },
);

PublicBoardPanelCustomFieldContainer.displayName = 'PublicBoardPanelCustomFieldContainer';
